/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Regenerate_Webhook_TokenInputs */

const cs_action_regenerate_webhook_token = /** @type {(inputs: Action_Regenerate_Webhook_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat nový token`)
};

const en_action_regenerate_webhook_token = /** @type {(inputs: Action_Regenerate_Webhook_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate token`)
};

/**
* | output |
* | --- |
* | "Regenerate token" |
*
* @param {Action_Regenerate_Webhook_TokenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_regenerate_webhook_token = /** @type {((inputs?: Action_Regenerate_Webhook_TokenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Regenerate_Webhook_TokenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_regenerate_webhook_token(inputs)
	return cs_action_regenerate_webhook_token(inputs)
});